import { useUser } from "@coworker/apprestructured/src/shared/hooks/users/useUser";
import { useTeamsByStore } from "@coworker/app/src/core/hooks/useStoreTeams";
import PersonAndTeam from "@coworker/apprestructured/src/task-management/components/PersonAndTeam/PersonAndTeam";
import { useMemo } from "react";
import {
  isLoading,
  LOADING,
} from "@coworker/apprestructured/src/task-management/loading";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";

export type UserAndTeamViewerFragmentConfigProps = {
  title: string;
  userIdField: string;
  teamIdField: string;
};

type UserAndTeamViewerFragmentProps = {
  configProps: UserAndTeamViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function UserAndTeamViewerFragment({
  configProps,
  commonProps,
}: UserAndTeamViewerFragmentProps) {
  const { title, userIdField, teamIdField } = configProps;
  const { task } = commonProps;
  const storeId = getTypedValue<string>(getByPath(task, "store_id"));
  const userId = getTypedValue<string>(getByPath(task, userIdField));
  const teamId = getTypedValue<string>(getByPath(task, teamIdField));
  const { data: user } = useUser(isLoading(userId) ? "" : userId);
  // Do this for now, but an endpoint for fetching users by ids would be preferred
  const { data: teams } = useTeamsByStore(isLoading(storeId) ? null : storeId);

  const userString = useMemo(() => {
    if (isLoading(task)) {
      return LOADING;
    }
    return userId ? (user?.fullName ?? "") : null;
  }, [task, user?.fullName, userId]);

  const teamString = useMemo(() => {
    if (isLoading(task)) {
      return LOADING;
    }
    return teams?.find(({ id }) => id === teamId)?.name ?? LOADING;
  }, [task, teamId, teams]);

  return <PersonAndTeam title={title} user={userString} team={teamString} />;
}

export default UserAndTeamViewerFragment;
